import { requestServerApi, serverApi } from '../api/api';
import { LessonLogType } from '../api/server';
import { IS_DEMO } from '../config/env-config';
import dayjs from 'dayjs';

export interface Lesson {
  companyId: string;
  roomId: string;
  lessonId: string;
  startDatetime: Date;
  endDatetime: Date;
}

type PostLessonEnteringLogParams = {
  userId: string;
  lessonId: string;
  companyId: string;
  lessonLogType: LessonLogType;
};
interface ILessonervice {
  fetchLessonInfo(companyId: string, roomId: string): Promise<Lesson | null>;
  postLessonEnteringLog(params: PostLessonEnteringLogParams): Promise<void>;
}
class LessonServiceApp implements ILessonervice {
  async postLessonEnteringLog(params: PostLessonEnteringLogParams): Promise<void> {
    const { userId, companyId, lessonId, lessonLogType } = params;
    await requestServerApi(() =>
      serverApi.mobileAppControllerCreateLessonLog(lessonId, companyId, userId, lessonLogType)
    );
  }

  async fetchLessonInfo(companyId: string, roomId: string): Promise<Lesson | null> {
    const response = await requestServerApi<any>(() =>
      serverApi.organizationsControllerGetLessonByRoomId(companyId, roomId)
    ).catch((error) => {
      console.error(error);
    });
    if (!Array.isArray(response?.data?.data)) {
      return null;
    }
    if (response.data.data.length === 0) {
      return null;
    }
    const lesson = response.data.data[0];
    return {
      lessonId: lesson.lesson_id,
      companyId: lesson.company_id,
      roomId: lesson.room_id,
      startDatetime: lesson.start_datetime,
      endDatetime: lesson.end_datetime
    };
  }
}
class LessonServiceDemo implements ILessonervice {
  async postLessonEnteringLog(params: PostLessonEnteringLogParams): Promise<void> {
    console.log('Demo mode: ' + this.postLessonEnteringLog.name);
  }
  async fetchLessonInfo(): Promise<Lesson | null> {
    console.log('Demo mode: fetchLessonInfo called');
    const now = dayjs();

    return {
      endDatetime: now.add(5, 'minute').toDate(),
      companyId: '',
      lessonId: '',
      roomId: '',
      startDatetime: new Date()
    };
  }
}
export const LessonService: new () => ILessonervice = IS_DEMO ? LessonServiceDemo : LessonServiceApp;
